import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import AppContext from "../../context/context";

// pages
import Home from "../home/home";
import Users from "../users/users";
import Stat from "../stat/stat";
import Servers from "../servers/server";


// components
import Appwrapper from "../../components/Appwrapper";
import Navigation from "./navigation";
import Activepage from "../../components/Activepage";
import Toast from "../../components/Toast";
import Constants from "../../constants";
import GlobalLoader from "../../components/GlobalLoader";

const Main = () => {
  // store variable
  const { store } = React.useContext(AppContext);
  const { user, app } = store;


  if (user.token === null) return <Redirect to="/login" />;


  return (
    <Appwrapper>
      <GlobalLoader />
      <Navigation user={user} name={app.name} />
      <Activepage>
        <Toast />
        <Switch>
          <Route path="/app/home" component={Home} />
          <Route path="/app/stat" component={Stat} />
          {user.type !== Constants.user_type.USER && <Route path="/app/users" component={Users} />}
          <Route path="/app/servers" component={Servers} />
          <Route path="" exact>
            <Redirect to={"/app/home"} />{" "}
          </Route>
        </Switch>
      </Activepage>
    </Appwrapper>
  );
};

export default Main;
